import React from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "primereact/button";
import { goToTop } from "./goToTop";

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
        goToTop();
    }

    return (
        <div className="error_page_container">
            <div className="error_page_area">
                <img src="/assets/images/error/404.svg" alt="404 - Not found" />
                <h3>Page Not Found!</h3>
                <p>Oops! The page you're looking for doesn't exist.</p>
                <Button
                    label="Go back"
                    icon="bi bi-arrow-left"
                    className="error_back_btn"
                    onClick={goBack}
                />
            </div>
        </div>
    )
}

export default NotFoundPage;